import routes from './routes';
import ReactDOM from "react-dom";
import { browserName, osName,osVersion,browserVersion,deviceDetect } from 'react-device-detect';
import * as CONST from 'utils/constants';
import queryString from 'utils/querystring';
import {getUID, setLang, appendEnvClass, translate } from 'utils/common';
import {getCookie,setCookie} from 'utils/cookie';
import dataservice from 'utils/dataservice'; 
import eventSubPub from 'utils/eventsubpub';

const defaultLang = 'en';
window.app = window.app || {pageParams : {lang:defaultLang}};
app.minImpressionsTime = 10000;   
 
const subPub = Object.seal({
    key: -1,
    currentCtxKey:-1,
    keyContext:{},
    subscribers: {},
    windowEvents:[CONST.WIN_CLICK,CONST.WIN_RESIZE,CONST.WIN_SCROLL],
    registeredEvents:[],
    subscribe: function(subscriberInfo,context,ctxKey) {//{event:handler... click:handler}
        this.subscribers[++this.key] = subscriberInfo;
        this.registerEvents(subscriberInfo);
        //this.keyContext[this.key] = null;
        if(context){
            this.keyContext[this.key] = {ctx:context,ctxKey:(ctxKey||this.currentCtxKey),key:this.key};
        }
        return this.key;
    },
    publish: function(args,eventName) {
        let keys = Object.keys(this.subscribers);
        for (var i in keys) {
            try {
                let sub = this.subscribers[keys[i]];
                if(sub[eventName]){
                    console.log(eventName+' called.....');
                    sub[eventName](args);
                } 
            } catch(ignore) {}
        }
    },
    generateNewCtxKey: function(removeCurrent){
        removeCurrent && this.unsubscribeUnMoutedCTx(false,this.currentCtxKey);
        this.currentCtxKey  = new Date().getTime();
        return this.currentCtxKey;
    },
    trigger: function(eventName,...arg){
      this.publish(arg,eventName);
    },
    unsubscribe: function(key) {
        console.log('unsubscribe => '+queryString.stringify(Object.keys(this.subscribers[key])));
        delete this.subscribers[key];
        delete this.keyContext[key];
    },
    unsubscribeUnMoutedCTx:function(allCtx,ctxKey){
        let keys = Object.keys(this.subscribers);
        for (var i in keys) {
            try {
                let context = this.keyContext[keys[i]];
                if(context && (allCtx || (context.ctxKey == ctxKey) || (context.ctx.updater && !context.updater.isMounted(context)))){
                    console.log('----------removed ctxt----------');
                    this.unsubscribe(context.key);
                }
            } catch(ignore) {}
        }
        //genNewCtx && this.generateNewCtxKey();
    },
    registerEvents: function(events){
      for (var key in events) {
        this.registerEvent(key);
      }
    },
    registerEvent:function(eventName){
      if(eventName && !this.registeredEvents.includes(eventName) && this.windowEvents.includes(eventName)){
        window.addEventListener(eventName, function (event) {
          app.events.publish(event,eventName);
        });
        this.registeredEvents.push(eventName);
      }
    }
  });


  async function loadConfig(){

    try {
        let response = await fetch(process.env.CONFIG_PATH);
        if (!response.ok) {
            throw Error(response.statusText);
        }
        let data = await response.json();
        // console.log(data);
        window.app = { ...window.app, ...data };
        app.pageParams = {...app.pageParams,...app.apis[CONST.PARAMS]};
        return data;
      } catch(err) {
        // catches errors both in fetch and response.json
        //alert(err);
        console.log(err);
        loadConfigFallback();
      }
    console.log('loadConfig---e');
    return null;
}
function loadConfigFallback(){

    fetch(process.env.CONFIG_PATH)
      .then(res => res.json())
      .then((data) => {
            console.log('data----- '+data.apis['portal-settings']);
            window.app = { ...window.app, ...data };
        },
        (error) => {
            console.log( "error -> "+error );
        }
    );
    
    // console.log('loadConfigFallback---e');
}

export function initApp(autoSignIn){
    app.apiConfig = loadConfig();
    //console.log('app.apiConfig '+app.apiConfig);
    //app.pageParams = {lang:defaultLang};
    getUID();
    ///autoSignIn -For local development
    app.autoSignIn = autoSignIn;
    app.defaultLocale = defaultLang;
    app.selectedLocale = defaultLang;
    app.routes = routes;
    app.pageUris = {};
    app.routesMap = {};
    app.categories = {};
    app.pageInfo = {query:{},params:{}};
    routes.forEach(function(route){
        app.pageUris[route.path] = route.name;
        app.routesMap[route.name] = route;
    });
    app.events = Object.create(subPub);    
    app.loaderCount = 0;
    //app.userId = 100;
    //if(app.enableSellerInteraction) {
        //set geolocation    
        
	app.events = Object.create(eventSubPub); 

        let evt = {};
        //evt[CONST.PATH_CHANGED] = ()=> app.ba.clearViewPort();
        app.events.subscribe(evt);    
    //}
    // console.log('-----------app initialized--------');
    //return config;
}

export function initPortalSettings(portsetting={},localeCode,langPos){
    if(langPos>0 && localeCode && portsetting.selectedLocale && portsetting.selectedLocale!=localeCode){
        // console.log('locale not match. reloading')
        let p = location.pathname.split('/');
        p.length > langPos && (p[langPos] = portsetting.selectedLocale);
        location.href = p.join('/') + location.search;
    }
    portsetting.minImpressionsTime = parseInt(portsetting.minImpressionsTime || app.minImpressionsTime);
    portsetting.selectedLocale = portsetting.selectedLocale || portsetting.defaultLocale;
    portsetting.locales = Array.isArray(portsetting.locales)?portsetting.locales:JSON.parse(portsetting.locales);
    window.app = { ...window.app, ...portsetting };
    app.pageParams.lang = portsetting.selectedLocale || portsetting.defaultLocale || defaultLang;
    setLang(app.pageParams.lang);
    appendEnvClass(app.defaultCountryCode);
    document.querySelector("meta[name='description']").setAttribute('content',translate('meta.description'))
}
